module.exports = __webpack_public_path__ + "static/media/logo.fcced0f3.svg";